const info = 
{
    title: "The Screen Series",
    type: "Script Series"
};

export default info;